import React from "react";

function PageNotFound() {
  return (
    <>
      <div style={{ marginTop: "157px" }}></div>
      <div>
        <h2>....Page Not Found Please Refresh</h2>
      </div>
    </>
  );
}

export default PageNotFound;
